import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.views.FranchiseeProjectResourceView.';
  public static readonly date = `${Id.prefix}date`;
  public static readonly quoteNo = `${Id.prefix}quoteNo`;
  public static readonly quoteTitle = `${Id.prefix}quoteTitle`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly pricingMetric = `${Id.prefix}pricingMetric`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly netAmount = `${Id.prefix}netAmount`;
  public static readonly purchaseOrderNo = `${Id.prefix}purchaseOrderNo`;
  public static readonly netCost = `${Id.prefix}netCost`;
  public static readonly quotesSectionHeader = `${Id.prefix}quotesSectionHeader`;
  public static readonly purchaseOrdersSectionHeader = `${Id.prefix}purchaseOrdersSectionHeader`;
  public static readonly cannotAcceptNewCopies = `${Id.prefix}cannotAcceptNewCopies`;
  public static readonly unableToCopyQuote = `${Id.prefix}unableToCopyQuote`;
}

export class LangFranchiseeProjectResourceView {
  private constructor() {}

  public static date(): string {
    return interpolate(Id.date);
  }

  public static quoteNo(): string {
    return interpolate(Id.quoteNo);
  }

  public static quoteTitle(): string {
    return interpolate(Id.quoteTitle);
  }

  public static author(): string {
    return interpolate(Id.author);
  }

  public static pricingMetric(): string {
    return interpolate(Id.pricingMetric);
  }

  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }

  public static status(): string {
    return interpolate(Id.status);
  }

  public static netAmount(): string {
    return interpolate(Id.netAmount);
  }

  public static purchaseOrderNo(): string {
    return interpolate(Id.purchaseOrderNo);
  }

  public static netCost(): string {
    return interpolate(Id.netCost);
  }

  public static quotesSectionHeader(): string {
    return interpolate(Id.quotesSectionHeader);
  }

  public static purchaseOrdersSectionHeader(): string {
    return interpolate(Id.purchaseOrdersSectionHeader);
  }

  public static cannotAcceptNewCopies(params: { quoteNumber: number; quoteNumberFormatted: string }): string {
    return interpolate(Id.cannotAcceptNewCopies, params);
  }

  public static unableToCopyQuote(): string {
    return interpolate(Id.unableToCopyQuote);
  }
}

export class FranchiseeProjectResourceViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.date, 'Date', 'Column title for quote date');
    register.add(Id.quoteNo, "{{glossary 'quote'}} No.", 'Column title for quote number');
    register.add(Id.quoteTitle, "{{glossary 'quote'}} Title", 'Column title for quote title');
    register.add(Id.author, 'Author', 'Column title for author');
    register.add(Id.pricingMetric, 'Pricing Metric (%)', 'Column title for pricing metric');
    register.add(Id.lastModified, 'Last Modified', 'Column title for last modified date');
    register.add(Id.status, 'Status', 'Column title for status');
    register.add(Id.netAmount, 'Net Amount', 'Column title for net amount');
    register.add(Id.purchaseOrderNo, "{{glossary 'purchase-order'}} No.", 'Column title for purchase order number');
    register.add(Id.netCost, 'Net Cost', 'Column title for net cost');
    register.add(Id.quotesSectionHeader, "{{glossary 'quote:plural'}}", 'Section header for quotes');
    register.add(
      Id.purchaseOrdersSectionHeader,
      "{{glossary 'purchase-order:plural'}}",
      'Section header for purchase orders'
    );
    register.add(
      Id.cannotAcceptNewCopies,
      "{{glossary 'quote'}} group {{quoteNumber}} cannot accept new copies. Do you want to make a new {{glossary 'quote'}} in this {{glossary 'project'}} based on {{quoteNumberFormatted}}",
      'Confirmation message when a quote group cannot accept new copies'
    );
    register.add(
      Id.unableToCopyQuote,
      "Unable to copy {{glossary 'quote'}}",
      'Toast message when unable to copy quote'
    );
  }
}
